export default {
  blue600: '#0069a6',
  green300: '#62a420',
  gray500: '#737373',
  blue400: '#1976d2',
  gray900: '#9e9e9e',
  red: '#C40503',
  orange: '#EF915C',
  yellow: '#EFC25C',
  lime: '#32CD32',
  green: '#219653',
  green550: '#4caf50',
  cwDefault: '#143d67',
  liteGreen: '#1fca3e',
}
